/* eslint-disable */
import React from 'react';
import { AccordionSection, LayerItem } from 'mapcontrols/components/subComponents';
import { RETAILER_SECTION_OBJ } from 'mapcontrols/constants';

const RetailersSection = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  activeLayerIds = [],
  onLayerToggle = () => {},
}) => {
  return (
    <AccordionSection
      title="Retailers"
      id="retailers"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {RETAILER_SECTION_OBJ.map((item) => (
        <LayerItem
          key={item.id}
          layerId={item.id}
          label={item.label}
          stackingOrder={item.stackingOrder}
          swatchStyle={item?.swatchStyle}
          subpanel={item?.subpanel}
          isActive={activeLayerIds.includes(item.id)}
          onToggle={onLayerToggle}
        />
      ))}
    </AccordionSection>
  );
};

export default RetailersSection;
